module.exports = __webpack_public_path__ + "static/flags/NR-41ce0e249d4de5687f1b5ecb708c8c1c.gif";